import matchQuery from './utility/matchQuery';

export default function toggleMenu() {
  const { documentElement } = document;
  const menu = document.querySelector('.js-menu');
  const menuContents = menu.querySelector('.js-menuContents');
  const trigger = document.querySelector('.js-menuTrigger');
  let isOpen = false;

  const open = () => {
    const height = window.innerHeight;
    menu.style.height = `${height}px`;
    menuContents.scrollTop = 0;

    documentElement.style.overflow = 'hidden';
    menu.setAttribute('aria-hidden', false);
    trigger.setAttribute('aria-expanded', true);
    isOpen = true;
  };

  const close = () => {
    documentElement.style.overflow = '';
    menu.setAttribute('aria-hidden', true);
    trigger.setAttribute('aria-expanded', false);
    isOpen = false;
  };

  const clickHandler = () => {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    const toggle = isExpanded ? close : open;

    toggle();
  };

  trigger.addEventListener('click', clickHandler);
  window.addEventListener('load', () => {
    trigger.dataset.initialized = true;
  });
  window.addEventListener('resize', () => {
    if (isOpen && matchQuery('lg')) {
      close();
    }
  });
}
